import React from 'react';
import styled from '@emotion/styled';

interface IProps {
  height?: string; // e.g: 10px
  width?: string; // e.g: 10px
}

const Wrapper = styled.div<IProps>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  color: transparent;
`;

const Gap: React.FC<IProps> = ({ width, height }) => {
  return (
    <Wrapper width={width} height={height}>
      {'&nbsp'}
    </Wrapper>
  );
};

export default Gap;
